module.exports = __webpack_public_path__ + "img/presentation.420a75ea.png";